import {useSuspenseQuery} from "@apollo/client";

import {useCurrentUserContext} from "@/components/context/hooks.ts";
import {LimitAndOffset} from "@/components/table/subComponents/Paginator/Paginator.tsx";
import {ContactGroupsListResult, GQL_CONTACT_GROUPS_LIST_QUERY} from "@/lib/queries/contacts.ts";
import {ContactGroupsTable} from "@/pages/contacts/list/components/table/ContactGroupsTable.tsx";

interface ContactsListProps {
  searchDebounced: string;
  pagination: LimitAndOffset;
  setPagination: (pagination: LimitAndOffset) => void;
}

export const ContactsList = ({searchDebounced, pagination, setPagination}: ContactsListProps) => {
  const {
    data: {
      contactGroups: {items, total},
      integrationProfiles,
    },
  } = useSuspenseQuery<ContactGroupsListResult>(GQL_CONTACT_GROUPS_LIST_QUERY, {
    variables: {
      ...pagination,
      sort: "name",
      search: searchDebounced,
    },
  });
  const {user} = useCurrentUserContext();
  return (
    <ContactGroupsTable
      items={items}
      integrationProfiles={integrationProfiles}
      hasWriteAccess={user?.has_write_access}
      isFiltered={searchDebounced.trim().length > 0}
      pagination={pagination}
      updatePagination={setPagination}
      totalRows={total}
    />
  );
};
